module.exports = __webpack_public_path__ + "static/602c8c62-37da-45f6-b1b4-fc514e0915d5-dfaf89793c5bdbbf33e6d2c8359d5f03.jpg";